import React, { useState, useEffect } from "react";
import axios from "axios";
import EditUserModal from "../modals/EditModal";
import { API_BASE, getAuthHeader } from "../api/api";

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newUser, setNewUser] = useState({ username: "", password: "" });

  const fetchUsers = async () => {
    try {
      const res = await axios.get(`${API_BASE}/users`, getAuthHeader());
      setUsers(res.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleEditClick = (user) => {
    setSelectedUser(user);
    setIsModalOpen(true);
  };

  const handleDelete = async (username) => {
    if (window.confirm(`Delete user ${username}?`)) {
      await axios.delete(`${API_BASE}/admin/users/${username}`, getAuthHeader());
      fetchUsers();
    }
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    await axios.post(`${API_BASE}/admin/register`, newUser, getAuthHeader());
    setNewUser({ username: "", password: "" });
    fetchUsers();
  };

  return (
    <div className="space-y-6">
      <section className="bg-white p-6 shadow rounded">
        <h2 className="text-xl font-bold mb-4 text-purple-600">Add New User</h2>
        <form onSubmit={handleCreate} className="flex gap-4">
          <input
            className="border p-2 flex-1"
            placeholder="Username"
            value={newUser.username}
            onChange={(e) => setNewUser({ ...newUser, username: e.target.value })}
          />
          <input
            className="border p-2 flex-1"
            type="password"
            placeholder="Password"
            value={newUser.password}
            onChange={(e) => setNewUser({ ...newUser, password: e.target.value })}
          />
          <button className="bg-purple-600 text-white px-6 rounded">Create</button>
        </form>
      </section>

      <section className="bg-white p-6 shadow rounded">
        <h2 className="text-xl font-bold mb-4">System Users</h2>
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-gray-50">
              <th className="p-2 border">Username</th>
              <th className="p-2 border">Role</th>
              <th className="p-2 border">Status</th>
              <th className="p-2 border">Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.username}>
                <td className="p-2 border font-medium">{u.username}</td>
                <td className="p-2 border text-gray-500">{u.role}</td>
                <td className="p-2 border">
                  <span className={`text-xs px-2 py-1 rounded ${u.is_enabled ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}>
                    {u.is_enabled ? "Enabled" : "Disabled"}
                  </span>
                </td>
                <td className="p-2 border">
                  <div className="flex gap-2">
                    <button onClick={() => handleEditClick(u)} className="text-xs bg-yellow-50 text-yellow-600 px-2 py-1 rounded border border-yellow-200">
                      Edit
                    </button>
                    {u.role !== "admin" && (
                      <button onClick={() => handleDelete(u.username)} className="text-xs bg-red-50 text-red-600 px-2 py-1 rounded border border-red-200">
                        Delete
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
      {isModalOpen && selectedUser && (
        <EditUserModal user={selectedUser} onClose={() => setIsModalOpen(false)} onUpdate={fetchUsers} />
      )}
    </div>
  );
};

export default UserManagement;